var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.125,
    stroke: "currentColor",
    strokeWidth: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4838 16.9C20.3785 19.8059 19.7695 22.3582 18.8904 24.1897C17.8697 26.3162 16.7503 27 16 27C15.2497 27 14.1303 26.3162 13.1096 24.1897C12.2305 22.3582 11.6215 19.8059 11.5162 16.9H20.4838ZM21.9847 16.9H28V15.4H21.9932C21.8429 8.77508 19.2172 3.5 16 3.5C12.7828 3.5 10.1571 8.77508 10.0068 15.4H4V16.9H10.0153C10.2367 23.3835 12.8316 28.5 16 28.5C19.1684 28.5 21.7633 23.3835 21.9847 16.9ZM11.5072 15.4C11.58 12.3699 12.2004 9.70454 13.1096 7.81026C14.1303 5.68385 15.2497 5 16 5C16.7503 5 17.8697 5.68385 18.8904 7.81026C19.7996 9.70454 20.42 12.3699 20.4928 15.4H11.5072Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.f23724286531caa9a385f60c1f47fbf7.svg";
export { ForwardRef as ReactComponent };